export const thousandFormatter = (value) =>
  value
    ?.toString()
    .slice(0, 16)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") || "";

export const thousandParser = (value) => value?.replace(/,/g, "") || "";
